import type { ReactNode } from 'react';

type Props = {
  code: string;
  name: string;
  icon?: string;
  amount: ReactNode;
  action?: ReactNode;
};

const SearchCell = ({ code, name, icon, amount, action }: Props) => (
  <div className="flex items-center gap-[2.4rem] py-[1.2rem]">
    <div className="flex min-w-0 flex-1 items-center gap-[1.2rem]">
      {icon ? (
        <img
          src={icon}
          alt=""
          className="size-[3.6rem] shrink-0 rounded-full"
        />
      ) : (
        <span className="size-[3.6rem] shrink-0 rounded-full bg-white/8" />
      )}

      <div className="flex min-w-0 flex-1 flex-col">
        <span className="medium5 text-primary truncate">{code}</span>
        <span className="p6 text-secondary truncate">{name}</span>
      </div>

      <div className="flex shrink-0 flex-col items-end text-end">{amount}</div>
    </div>

    {action}
  </div>
);

export { SearchCell };
